/*
 * master-download.js — выдача ГОТОВОГО файла с нашего диска: подготовка отдельным
 * запросом, а байты ведёт менеджер загрузок браузера.
 *
 * ЗАЧЕМ ОТДЕЛЬНЫЙ ПРИМИТИВ. 17.09.2026, обращение gr.yushkov («Почему не могу
 * скачать в формате wav»): страница тянула мастер 35 МБ через `fetch` → `blob`.
 * На мобильной сети это ноль доставленных файлов — сервер шесть раз отдал файл
 * целиком, до телефона доехало 0–11 %, и каждая попытка начиналась с нуля.
 *
 * Замер лейнов (35 МБ, обрыв каждые 3 МБ, настоящий Chrome 153 и Chromium —
 * числа совпали; `tests/playwright/wav-delivery-lanes-bench.mjs`):
 *   fetch→blob ................ 0 % при ЛЮБОМ обрыве, всё скачанное теряется
 *   прямая ссылка + кэш ....... 1.00× трафика, докачка с места обрыва
 *   прямая ссылка + tempnam ... 1.43× (If-Range отвергается, каждый раз с нуля)
 * Проверено на проде: четыре обрыва подряд на настоящем файле 35.6 МБ дали
 * 4.9 → 9.1 → 13.3 → 17.5 МБ, итог побайтно равен оригиналу.
 *
 * УРОКИ, КАЖДЫЙ ОПЛАЧЕН ОТДЕЛЬНЫМ ДЕФЕКТОМ (не упрощать):
 *  1. Байты качает БРАУЗЕР. Он умеет докачку, фон, «Возобновить» и переживает
 *     закрытие вкладки; вкладка не умеет ничего из этого и держит файл в памяти.
 *  2. Два шага. Первое нажатие может ждать сборки (у нового трека мастера ещё
 *     нет), и всё это время прямая ссылка выглядела бы как «ничего не
 *     происходит». Сначала «подготовь» (JSON, отменяемо, с весом), потом ссылка.
 *     Заодно отказ приходит как JSON, а не как страница ошибки, сохранённая под
 *     именем песни.
 *  3. Занятая кнопка остаётся НАЖИМАЕМОЙ: повторное нажатие отменяет. Глухой
 *     `pointer-events:none` и был тем, что человек описал как «не работает» —
 *     тапы проваливались в контейнер (пять серий rage_click по DIV).
 *  4. Клик по ссылке ПОСЛЕ ожидания браузер принимает (проверено на 15 с), так
 *     что второй шаг не обязан укладываться в исходный жест.
 *  5. …но ОДНА загрузка на нажатие остаётся законом. Три кнопки подряд (FLAC,
 *     WAV, MP3) дают три подготовки, которые кончаются в одну секунду, и три
 *     ссылки без нажатия между ними: браузер отдаёт первую, а вторая отравляет
 *     вкладку — дальше молча теряется каждая загрузка на любой странице сайта в
 *     ней до F5 (замер 17.10.2026 на Яндексе 26.8, комментарий #1935). Бюджет
 *     держит не этот файл, а дверь `window.__downloadLink` в timbrica-core.js:
 *     лишняя ссылка ждёт на полосе «Сохранить», и дверь отвечает false.
 *
 * Использование:
 *   window.__masterDownload(el, {
 *       url,                       // базовый адрес файла
 *       query,                     // что просим: 'master=wav' | 'master=flac' | 'kbps=320'
 *       name,                      // имя для человека
 *       labels: { preparing, failed, started, mb },
 *       onStart(), onDone(bytes), onFail()   // необязательные
 *   });
 * Возвращает true, если работа НАЧАТА, и false, если этим нажатием её отменили.
 */
(function (w) {
    'use strict';

    var live = new WeakMap();   // элемент → живая подготовка (для отмены)

    function qsuf(u, q) {
        return u + (u.indexOf('?') < 0 ? '?' : '&') + q;
    }

    function fmtMB(bytes, unit) {
        if (!(bytes > 0)) { return ''; }
        return (bytes / 1048576).toFixed(bytes > 10485760 ? 0 : 1) + ' ' + (unit || 'MB');
    }

    /* Подпись занятой кнопки: «Готовим…» вместо немого серого прямоугольника.
       Исходный текст помним на самом элементе — карточка может перерисоваться. */
    function label(el, text) {
        var span = el.querySelector('[data-md-label]') || el.querySelector('[data-sg-label]');
        if (!span) { return; }
        if (text) {
            if (!el.hasAttribute('data-md-was')) { el.setAttribute('data-md-was', span.textContent); }
            span.textContent = text;
        } else if (el.hasAttribute('data-md-was')) {
            span.textContent = el.getAttribute('data-md-was');
            el.removeAttribute('data-md-was');
        }
    }

    function finish(el) {
        live.delete(el);
        el.classList.remove('is-busy');
        el.removeAttribute('aria-busy');
        label(el, null);
    }

    function start(el, opts) {
        opts = opts || {};
        var strings = opts.labels || {};

        var running = live.get(el);
        if (running) {          // повторное нажатие по занятой кнопке = «отмени»
            running.abort();
            finish(el);
            return false;
        }

        var ctrl = new AbortController();
        live.set(el, ctrl);
        el.classList.add('is-busy');
        el.setAttribute('aria-busy', 'true');
        label(el, strings.preparing || '…');
        if (opts.onStart) { try { opts.onStart(); } catch (e) {} }

        fetch(qsuf(opts.url, opts.query + '&prepare=1'), { credentials: 'same-origin', signal: ctrl.signal })
            .then(function (r) { if (!r.ok) { throw new Error('http ' + r.status); } return r.json(); })
            .then(function (j) {
                if (!j || !j.ok) { throw new Error('not ready'); }
                // Файл готов и лежит у нас — дальше качает браузер, через общую
                // дверь ссылок (бюджет «один файл на нажатие» + учёт выдачи).
                var href = qsuf(opts.url, opts.query), handed = true;
                if (w.__downloadLink) {
                    handed = w.__downloadLink(href, opts.name || 'download');
                } else {
                    var a = document.createElement('a');
                    a.href = href;
                    a.download = opts.name || 'download';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
                // Ссылку придержала дверь загрузок (17.10.2026, комментарий #1935):
                // подготовка кончилась без нового нажатия после ДРУГОЙ загрузки —
                // FLAC, WAV и MP3, нажатые подряд, возвращаются в одну секунду, а
                // браузер даёт один файл на нажатие, и второй файл без нажатия
                // молча убивает загрузки всей вкладки. Файл ждёт на полосе
                // «Сохранить» — «Скачивание началось» здесь было бы неправдой.
                if (!handed) {
                    if (opts.onDone) { try { opts.onDone(j.bytes || 0, { held: true }); } catch (e) {} }
                    return;
                }
                if (w.__toast && strings.started) {
                    var size = fmtMB(j.bytes || 0, strings.mb);
                    w.__toast(size ? strings.started + ' · ' + size : strings.started, 'success');
                }
                if (opts.onDone) { try { opts.onDone(j.bytes || 0); } catch (e) {} }
            })
            .catch(function (e) {
                if (e && e.name === 'AbortError') { return; }    // отменил сам — молчим
                if (w.__toast && strings.failed) { w.__toast(strings.failed, 'warning'); }
                if (opts.onFail) { try { opts.onFail(e); } catch (err) {} }
            })
            .finally(function () { finish(el); });

        return true;
    }

    start.fmtMB = fmtMB;
    start.isBusy = function (el) { return live.has(el); };
    w.__masterDownload = start;
})(window);
